import { useQuery } from '@tanstack/react-query';

import { shippingOptionsQuery } from './shippingOptionsQuery';
import { useLocale } from '@/shared/hooks/useLocale';

export function useShippingOptions() {
  return useQuery(shippingOptionsQuery(useLocale()));
}
